module.exports = __webpack_public_path__ + "img/dizhi.12709097.png";